import axios from 'axios';
import {safaricomConfig} from "@/config";

export async function getEvinaAuthToken() {
    const response = await axios.get(`${safaricomConfig.host}/evina/get-auth-token`);
    return response.data;
}

export async function requestEvinaPaymentUrl(token, pricePoint, offerCode, hashedMsisdn, gameUrl, errorUrl) {
    try {
        const response = await axios.post(`${safaricomConfig.host}/evina/request-payment-url`, {
            token, pricePoint, offerCode, hashedMsisdn, gameUrl, errorUrl
        });
        return response.data;
    } catch (error) {
        console.error("Error requesting payment URL:", error.response?.data || error.message);
        throw error;
    }
}
